<template>
  <div>
    <el-row>
      <el-col>
        <el-form :model="searchForm" ref="searchForm" :inline="true">
          <el-form-item label="日期范围：">
            <el-date-picker size="medium" v-model="searchForm.DAY_INTERVAL" type="daterange" align="right" unlink-panels range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions" value-format="yyyy-MM-dd"></el-date-picker>
          </el-form-item>
          <el-form-item label="标准Sku：">
            <el-input size="medium" v-model="searchForm.STANDARD_PRODUCT_CODE" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-button size="medium" type="primary" @click="serch()" :loading="loadSearch">筛选</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-button size="medium" type="primary" plain @click="entryOrder">记录导出</el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-table :data="tableData" border stripe style="width: 100%;margin-top:20px">
          <el-table-column type="index" width="50" label="序号"></el-table-column>
          <el-table-column prop="GYS_PRODUCT_CODE" label="原SKU"></el-table-column>
          <el-table-column prop="STANDARD_PRODUCT_CODE" label="标准SKU"></el-table-column>
          <el-table-column prop="NAME" label="供应商名称"></el-table-column>
          <el-table-column prop="PRODUCT_NAME" label="产品名称"></el-table-column>
          <el-table-column prop="TYPE_UNIT" label="单位"></el-table-column>
          <el-table-column prop="REPLACE_DATE" label="替换日期"></el-table-column>
          <el-table-column prop="BEFORE_BATCH" label="原产品批次号"></el-table-column>
          <el-table-column prop="AFTER_BATCH" label="新产品批次号"></el-table-column>
          <el-table-column prop="COUNT" label="数量"></el-table-column>
          <!-- <el-table-column label="操作" width="100">
                        <template slot-scope="scope">
                            <el-button  type="text" size="small" icon="el-icon-view" @click="dataY(scope.row)">查看</el-button>
                        </template>
                    </el-table-column> -->
        </el-table>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24" style="text-align: right">
        <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
          layout="total,prev, pager, next, jumper" :total="totalCount"></el-pagination>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import http from '@/assets/common/http';

export default {
  data() {
    return {
      pickerOptions: [],
      loadSearch: false,
      tableData: [
      ],
      formLableWidth: '120px',
      PRODUCT_TYPE_LIST: [{ typeId: 0, name: '未上传' }, { typeId: 1, name: '已上传' }],
      searchForm: {
        SEND_DAY: new Date().getTime() + 3600 * 1000 * 24,
        value: 0,
      },
      val: [],
      PRODUCT_CODE: [],
      fileList: [],
      file_name: '',
      exportOrderDialog: false,
      orderForm: {
        orderName: 'qualification',
        domains: [{
          fileList: [],
          value: '',
          orderName: 'qualification',
        }],
      },
      X: 1,
      upNum: 0,
      totalCount: 0,
      // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
      pageSize: Number(localStorage.getItem('SMP_PAGE_COUNT')) || 10,
      currentPage: 1,
    };
  },
  created() {
    if (this.SAVE_QUALIFIC_LIST) {
      this.searchForm = this.SAVE_QUALIFIC_LIST.CONDITION;
      this.currentPage = this.SAVE_QUALIFIC_LIST.CURRENT_PAGE;
    } else {
      this.currentPage = 1;
    }
    this.queryData();
  },
  computed: {
    // 上一次的搜索结果和条件
    SAVE_QUALIFIC_LIST() {
      return this.$store.state.SAVE_QUALIFIC_LIST;
    },
  },
  methods: {
    serch() {
      this.currentPage = 1;
      this.queryData();
    },
    handleCurrentChange(e) {
      this.currentPage = e;
      this.queryData();
    },
    queryData() {
      const params = {
        SERVICE_ID: '10035',
        OTYPE: 37,
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
        // SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
        SUPPLIER_ID: 887,
        PAGE_SIZE: this.pageSize,
        PAGE_INDEX: this.currentPage - 1,
      };
      if (this.searchForm.DAY_INTERVAL) {
        params.START_DAY = this.searchForm.DAY_INTERVAL[0];
        params.END_DAY = this.searchForm.DAY_INTERVAL[1];
      }
      if (this.searchForm.STANDARD_PRODUCT_CODE) {
        params.STANDARD_PRODUCT_CODE = this.searchForm.STANDARD_PRODUCT_CODE;
      }
      http.post(params).then((result) => {
        if (result.length !== 0) {
          this.tableData = result[0].RECORD_LIST;
          this.totalCount = result[0].TOTAL_COUNT;
          this.$store.dispatch('SET_SAVE_QUALIFIC_LIST', {
            CONDITION: this.searchForm,
            CURRENT_PAGE: this.currentPage,
          });
        } else {
          this.totalCount = 0;
          this.tableData = [];
          this.$message.show({ text: '暂无数据', type: 'warning' });
        }
      }).catch((err) => {
        this.$message.show({
          text: err,
          type: 'error',
        });
      });
    },
    // 记录导出
    entryOrder() {
      if (document.body.style.cursor === 'wait') {

      } else {
        document.body.style.cursor = 'wait';
        try {
          this.exportLoading = true;
          const params = {
            SERVICE_ID: '10035',
            OTYPE: 38,
            SUPPLIER_ID: 887,
          };
          if (this.searchForm.DAY_INTERVAL) {
            params.START_DAY = this.searchForm.DAY_INTERVAL[0];
            params.END_DAY = this.searchForm.DAY_INTERVAL[1];
          }
          if (this.searchForm.STANDARD_PRODUCT_CODE) {
            params.STANDARD_PRODUCT_CODE = this.searchForm.STANDARD_PRODUCT_CODE;
          }
          http.post(params).then((result) => {
            window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally {}
      }
    },
  },
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/SKUManage/changeKeepSku.vue